enum TokenConstants {
  CD_CATEGORY = 'ext_categoryCd',
  CD_HEALTH_INSURANCE = 'ext_healthInsuranceCd',
  CD_ORIGIN = 'ext_originCd',
  CD_PHYSICAL_PERSON = 'ext_physicalCd',
  ID_SUBJECT = 'ext_idSubject',
  IE_LOGIN_TYPE = 'ext_loginType',
  PATIENT_ID = 'ext_patientId',
}

export default TokenConstants;
